var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "fee-item-details clearfix transition-slow",
      class: { show: _vm.isExtended },
      attrs: { id: "details" },
    },
    [
      _vm.$i18n.locale === "cl" &&
      _vm.payment.lateCharges > 0 &&
      _vm.showRemoveLateCharges &&
      _vm.noLateChargesRemainingDays <= 0
        ? _c(
            "div",
            { staticClass: "remove-late-charges details-footer" },
            [
              _c("h4", { staticClass: "details-header big-size-text" }, [
                _vm._v("Descontar gastos de cobranza hasta"),
              ]),
              _c(
                "b-field",
                { attrs: { grouped: "", "group-multiline": "" } },
                [
                  _c("b-datepicker", {
                    staticClass: "is-primary is-two-thirds mobile-field",
                    attrs: {
                      id: `${_vm.payment.operationId}-${_vm.payment.paymentNumber}-no-late-charges-until-datepicker`,
                      placeholder: "hasta",
                      size: "is-small",
                      "append-to-body": "",
                      rounded: "",
                      locale: "es-ES",
                    },
                    model: {
                      value: _vm.noLateChargesUntilAsDate,
                      callback: function ($$v) {
                        _vm.noLateChargesUntilAsDate = $$v
                      },
                      expression: "noLateChargesUntilAsDate",
                    },
                  }),
                  _c(
                    "button",
                    {
                      staticClass:
                        "button is-button-primary mobile-field is-rounded",
                      on: {
                        click: () => {
                          _vm.$emit("remove-late-charges", {
                            operationId: _vm.payment.operationId,
                            paymentNumber: _vm.payment.paymentNumber,
                            noLateChargesUntil: _vm.noLateChargesUntil,
                            companyOperationId:
                              _vm.currentOperation.companyOperationId,
                          })
                        },
                      },
                    },
                    [_vm._v(" Descontar ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.payment.noLateChargesUntil &&
      _vm.showRemoveLateCharges &&
      _vm.noLateChargesRemainingDays >= 0
        ? _c("div", [
            _c(
              "button",
              {
                staticClass: "button is-button-primary mobile-field is-rounded",
                attrs: { title: "Reversar descuento de gasto de cobranza" },
                on: {
                  click: () => {
                    _vm.$emit("undo-remove-late-charges", {
                      operationId: _vm.currentOperation._id,
                      paymentNumber: _vm.payment.paymentNumber,
                      companyOperationId:
                        _vm.currentOperation.companyOperationId,
                    })
                  },
                },
              },
              [_vm._v(" Reversar descuento ")]
            ),
          ])
        : _vm._e(),
      _c("h4", { staticClass: "details-header big-size-text" }, [
        _vm._v(_vm._s(_vm.$t("feeDetail"))),
      ]),
      _vm.$i18n.locale === "cl"
        ? _c("div", { staticClass: "details-column1" }, [
            _c("table", { staticClass: "table-data small-size-text" }, [
              _c("tr", [
                _c("td", { staticClass: "table-title" }, [
                  _vm._v("Amortización:"),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      `${_vm.monetarySign} ${_vm.formatNumber(
                        _vm.payment.amortization
                      )}`
                    )
                  ),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "table-title" }, [_vm._v("Interés:")]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      `${_vm.monetarySign} ${_vm.formatNumber(
                        _vm.payment.interest
                      )}`
                    )
                  ),
                ]),
              ]),
              !!_vm.payment.monthlyDebtorLifeInsurance
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v(_vm._s(`${_vm.getlifeInsuranceLabel()}`)),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.monthlyDebtorLifeInsurance
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.monthlyCodebtorLifeInsurance
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Desgravamen codeudor:"),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.monthlyCodebtorLifeInsurance
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.monthlyUnemploymentInsurance
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Seguro de cesantía:"),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.monthlyUnemploymentInsurance
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.monthlyFireInsurance
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Seguro incendio y sismo:"),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.monthlyFireInsurance
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.monthlyCreditInsurance
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Seguro de Crédito:"),
                    ]),
                    _c("td", { attrs: { id: "monthly-credit-insurance" } }, [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.monthlyCreditInsurance
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.monthlyCreditInsurancePrize
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Seguro de Crédito (Premio):"),
                    ]),
                    _c("td", { attrs: { id: "monthly-credit-insurance" } }, [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.monthlyCreditInsurancePrize
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.monthlyCreditInsuranceExpenses
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Seguro de Crédito (Costo):"),
                    ]),
                    _c("td", { attrs: { id: "monthly-credit-insurance" } }, [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.monthlyCreditInsuranceExpenses
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.lateInterest
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Interés por mora:"),
                    ]),
                    _c("td", [
                      _vm._v(
                        " " +
                          _vm._s(
                            `${_vm.monetarySign} ${_vm.formatNumber(
                              _vm.payment[
                                `${
                                  _vm.type === "MORTGAGE" ||
                                  _vm.operation.considerLate ||
                                  _vm.operation.considerLateInterest
                                    ? "lateInterest"
                                    : "secondaryCurrencyLateInterest"
                                }`
                              ]
                            )}`
                          ) +
                          " "
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.lateCharges || _vm.noLateChargesRemainingDays > 0
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Gastos de Cobranza:"),
                    ]),
                    _c(
                      "td",
                      {
                        staticClass: "has-text-right",
                        attrs: { id: "late-charges" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              `${_vm.monetarySign} ${_vm.formatNumber(
                                _vm.payment[
                                  `${
                                    _vm.type === "MORTGAGE" ||
                                    _vm.operation.considerLate ||
                                    _vm.operation.considerLateCharges
                                      ? "lateCharges"
                                      : "secondaryCurrencyLateCharges"
                                  }`
                                ]
                              )}`
                            ) +
                            " "
                        ),
                        _c("br"),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.noLateChargesRemainingDays > 0
                                ? `(liberado hasta ${_vm.dateToFormatedString(
                                    _vm.payment.noLateChargesUntil
                                  )})`
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm.$i18n.locale === "br"
        ? _c("div", { staticClass: "details-column1" }, [
            _c("table", { staticClass: "table-data small-size-text" }, [
              _c("tr", [
                _c("td", { staticClass: "table-title" }, [
                  _vm._v("Amortização:"),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      `${_vm.monetarySign} ${_vm.formatNumber(
                        _vm.payment.amortizationIUB
                      )}`
                    )
                  ),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "table-title" }, [_vm._v("Juros:")]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      `${_vm.monetarySign} ${_vm.formatNumber(
                        _vm.payment.interestIUB
                      )}`
                    )
                  ),
                ]),
              ]),
              !!_vm.payment.debtorLifeInsuranceFee
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Seguro MIP:"),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.debtorLifeInsuranceFee
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.codebtorLifeInsuranceFee
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Seguro MIP Codeudor:"),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.codebtorLifeInsuranceFee
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.monthlyFireInsurance
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Seguro DFI:"),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.monthlyFireInsurance
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.monthlyCreditInsurance
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Seguro de Credito:"),
                    ]),
                    _c("td", { attrs: { id: "monthly-credit-insurance" } }, [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.monthlyCreditInsurance
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.lateChargesFine
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Multa por atraso:"),
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.lateChargesFine
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              !!_vm.payment.totalLateInterest ||
              _vm.noLateChargesRemainingDays > 0
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Juros por atraso:"),
                    ]),
                    _c(
                      "td",
                      {
                        staticClass: "has-text-right",
                        attrs: { id: "late-charges" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              `${_vm.monetarySign} ${_vm.formatNumber(
                                _vm.payment.totalLateInterest
                              )}`
                            ) +
                            " "
                        ),
                        _c("br"),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.noLateChargesRemainingDays > 0
                                ? `(liberado hasta ${_vm.dateToFormatedString(
                                    _vm.payment.noLateChargesUntil
                                  )})`
                                : ""
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm.$i18n.locale === "pe"
        ? _c("div", { staticClass: "details-column1" }, [
            _c("table", { staticClass: "table-data small-size-text" }, [
              _c("tr", [
                _c("td", { staticClass: "table-title" }, [
                  _vm._v("Amortización:"),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      `${_vm.monetarySign} ${_vm.formatNumber(
                        _vm.payment.amortization
                      )}`
                    )
                  ),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "table-title" }, [
                  _vm._v("Fecha de Vencimento:"),
                ]),
                _c("td", [_vm._v(_vm._s(_vm.payment.dueDate))]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "table-title" }, [
                  _vm._v("Cuota Mensual:"),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      `${_vm.monetarySign} ${_vm.formatNumber(
                        _vm.payment.monthlyPayment
                      )}`
                    )
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.$i18n.locale === "cl"
        ? _c("div", { staticClass: "details-column2" }, [
            _c("table", { staticClass: "table-data small-size-text" }, [
              _c("tr", { staticClass: "med-size-text" }, [
                _c("td", { staticClass: "table-title" }, [_vm._v("Cuota:")]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.payment.paymentNumber +
                        "/" +
                        _vm.currentOperation?.termAsMonths
                    )
                  ),
                ]),
              ]),
              _vm.type !== "COMPLEMENTARY"
                ? _c("tr", { staticClass: "med-size-text" }, [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Total en UF:"),
                    ]),
                    _c("td", { staticClass: "significant-data" }, [
                      _vm._v(
                        _vm._s(
                          `${_vm.monetarySign} ${_vm.formatNumber(
                            _vm.payment.totalMonthlyPayment
                          )}`
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.type !== "COMPLEMENTARY"
                ? _c("tr", [
                    _c("td", { staticClass: "table-title" }, [
                      _vm._v("Valor UF del día:"),
                    ]),
                    _c("td", [
                      _vm._v(
                        "$ " +
                          _vm._s(
                            _vm.formatNumber(
                              _vm.payment.secondaryCurrencyFactor
                            )
                          )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c("tr", { staticClass: "med-size-text" }, [
                _c("td", { staticClass: "table-title" }, [
                  _vm._v(
                    "Total" +
                      _vm._s(
                        _vm.type === "MORTGAGE" || _vm.type === "PARKING"
                          ? " en pesos:"
                          : ":"
                      )
                  ),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      `$ ${_vm.formatNumber(
                        _vm.payment.secondaryCurrencyTotalMonthlyPayment
                      )}`
                    )
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.$i18n.locale === "br"
        ? _c("div", { staticClass: "details-column2" }, [
            _c("table", { staticClass: "table-data small-size-text" }, [
              _c("tr", { staticClass: "med-size-text" }, [
                _c("td", { staticClass: "table-title" }, [
                  _vm._v("Valor total da parcela:"),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      `${_vm.monetarySign} ${_vm.formatNumber(
                        _vm.payment.totalMonthlyPayment
                      )}`
                    )
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.$i18n.locale === "pe"
        ? _c("div", { staticClass: "details-column2" }, [
            _c("table", { staticClass: "table-data small-size-text" }, [
              _c("tr", [
                _c("td", { staticClass: "table-title" }, [
                  _vm._v("Cargos por Mora:"),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      `${_vm.monetarySign} ${_vm.formatNumber(
                        _vm.payment.lateCharges
                      )}`
                    )
                  ),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "table-title" }, [
                  _vm._v("Días de Mora:"),
                ]),
                _c("td", [
                  _vm._v(_vm._s(_vm.formatNumber(_vm.payment.lateDays))),
                ]),
              ]),
              _c("tr", { staticClass: "med-size-text" }, [
                _c("td", { staticClass: "table-title" }, [
                  _vm._v("Valor total de la cuota:"),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      `${_vm.monetarySign} ${_vm.formatNumber(
                        _vm.payment.totalMonthlyPayment
                      )}`
                    )
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }